import { ref } from 'vue'
import { api } from '@/services/api.js'

const flagCache = new Map()

/**
 * Fetch a config flag by slug and resolve against the current brand tenant.
 * Returns { enabled, loading } refs.
 */
export function useConfigFlag(slug) {
  const enabled = ref(false)
  const loading = ref(true)

  if (flagCache.has(slug)) {
    enabled.value = flagCache.get(slug)
    loading.value = false
  } else {
    api.get(`/flags/${slug}?tenant=${__DICT__.brand}`)
      .then(res => {
        enabled.value = !!res.enabled
        flagCache.set(slug, enabled.value)
      })
      .catch(() => {
        enabled.value = false
        flagCache.set(slug, false)
      })
      .finally(() => {
        loading.value = false
      })
  }

  return { enabled, loading }
}
